import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { instanceAxios } from '../../InstanceAxios';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DropZone from '../../components/DropZone';
import ListOfUsers from '../../components/ListOfUsers';
import moment from 'moment';
import 'moment/locale/pt-br';
import queryString from 'query-string';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';

const useStyles = (theme) => ({
  root: {
    height: '100vh',
    overflow: 'auto',
    width: '95%',
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '45%',
    height: '30%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  selectTipo: {
    width: 200,
  },
  modalAddTitle: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 2),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

class CndComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    moment.locale('pt-br');
  }

  state = {
    cnd: [],
    originalCND: [],
    filterText: '', // Filter text
    isModalOpen: false, // Modal open state
    modalPosition: { top: 0, left: 0 }, // Position of the modal
    modalColumnId: null,
    orderBy: '', // Coluna pela qual estamos ordenando
    columns: [
      {
        id: 'dataGeracao',
        label: 'Data Geração',
        minWidth: 170,
        filterable: true,
      },
      { id: 'situacao', label: 'Situação', minWidth: 170, filterable: true },
      { id: 'tipo', label: 'Tipo', minWidth: 170, filterable: true },
    ],
    idUsuario: null,
    nomeUsuario: '',
    dataGeracao: null,
    situacao: null,
    openWarning: false,
    openWarningSend: false,
    openError: false,
    openSucess: false,
    openModalAddFile: false,
    fileName: '',
    fileSelect: null,
    tipo: '',
    ready: true,
  };

  componentWillMount() {
    if (this.props.location.search) {
      const values = queryString.parse(this.props.location.search);
      this.setState({
        idUsuario: values.cliente,
        nomeUsuario: values.nomeCliente,
        tipo: values.tipo,
      });
      this.handleChangeUsuario(values.cliente, values.tipo);
      this.setState({ ready: false });
    }
  }

  saveButton = async () => {
    if (
      !this.state.fileSelect ||
      !this.state.idUsuario ||
      !this.state.dataGeracao ||
      !this.state.situacao
    ) {
      this.setState({ openWarningSend: true });
    } else {
      this.setState({ ready: !this.state.ready });
      const data = new FormData();
      data.append('file', this.state.fileSelect);
      data.append('id_usuario', this.state.idUsuario);
      data.append('data_geracao', this.state.dataGeracao);
      data.append('situacao', this.state.situacao);
      data.append('tipo_servico', this.state.tipo);
      await this.axios
        .post(`/uploadCND`, data)
        .then((res) => {
          const cert = this.state.cnd;
          cert.push({
            data_geracao: this.state.dataGeracao,
            situacao: this.state.situacao,
            tipo_servico: this.state.tipo,
          });
          this.setState({ cnd: cert });
          this.setState({ ready: !this.state.ready });
          this.setState({ openSucess: !this.state.openSucess });
          this.setState({ openModal: false });
          this.setState({ openModalAddFile: false });
          this.setState({ fileSelect: null });
          this.setState({ fileName: '' });
          this.setState({ dataGeracao: null });
          this.setState({ situacao: null });
        })
        .catch((err) => {
          console.log('err');
          console.log(err);
          this.setState({ ready: true });
          this.setState({ openError: true });
          this.setState({ openModal: false });
          this.setState({ openModalAddFile: false });
          this.setState({ fileSelect: null });
          this.setState({ fileName: '' });
          this.setState({ dataGeracao: null });
          this.setState({ situacao: null });
        });
    }
  };

  handleButtonClick = (file) => {
    this.setState({ openModalAddFile: false });
    if (file) {
      this.setState({ fileSelect: file[0] });
      this.setState({ fileName: file[0].name });
    }
  };

  handleChangeUsuario = async (id, t = this.state.tipo) => {
    const url =
      this.state.tipo === 'CND MUNICIPAL'
        ? `/historicoCertidaoNegativaUsuario/${id}?tipoServico=${t}`
        : `/historicoCertidaoNegativaUsuario/${id}`;

    this.setState({ idUsuario: id });
    this.setState({ ready: false });
    await this.axios
      .get(`${url}`)
      .then((resp) => {
        this.setState({ cnd: resp.data.historico });
        this.setState({ originalCND: resp.data.historico });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openWarning: true });
        this.setState({ cnd: [] });
        this.setState({ ready: true });
      });
  };

  handleChangeTipo = async (event) => {
    const url =
      event.target.value === 'CND MUNICIPAL'
        ? `/historicoCertidaoNegativaUsuario/${this.state.idUsuario}?tipoServico=${event.target.value}`
        : `/historicoCertidaoNegativaUsuario/${this.state.idUsuario}`;

    this.setState({ tipo: event.target.value });
    this.setState({ ready: false });
    await this.axios
      .get(`${url}`)
      .then((resp) => {
        this.setState({ cnd: resp.data.historico });
        this.setState({ originalCND: resp.data.historico });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openWarning: true });
        this.setState({ cnd: [] });
        this.setState({ ready: true });
      });
  };

  handleModal = () => {
    const status = !this.state.openModal;
    this.setState({ openModal: status });
    this.setState({ fileSelect: null });
    this.setState({ fileName: '' });
    this.setState({ dataGeracao: null });
    this.setState({ situacao: null });
  };

  handleAddFile = (classes) => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.openModalAddFile}
        onClose={() => this.setState({ openModalAddFile: false })}
      >
        <div className={classes.modalAddTitle}>
          <DropZone handleButtonClick={this.handleButtonClick} />
        </div>
      </Modal>
    );
  };

  clickAlert = () => {
    this.setState({ openError: false });
    this.setState({ openSucess: false });
    this.setState({ openWarning: false });
    this.setState({ openWarningSend: false });
  };

  openModal = (event, columnid) => {
    this.setState({ filterText: '' });
    const rect = event.target.getBoundingClientRect();
    this.setState({
      isModalOpen: true,
      modalPosition: { top: rect.bottom, left: rect.left },
      modalColumnId: columnid,
    });
  };

  handleFilterTextChange = (event) => {
    this.setState({ filterText: event.target.value });
  };

  // Function to filter the table data
  filterTable = () => {
    this.setState({ isModalOpen: false });
    const { cnd, filterText, modalColumnId } = this.state;
    const filteredDas = cnd.filter((item) => {
      const value = this.getValueColumnId(modalColumnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    this.setState({ cnd: filteredDas });
  };

  getValueColumnId(columnId, rowData) {
    columnId = columnId.replace(/"/g, '');
    const parts = columnId.split('.');
    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  }
  clearFilter = () => {
    this.setState({ isModalOpen: false });
    this.setState({ filterText: '', cnd: this.state.originalCND });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleRequestSort = (property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  sortTable = (property) => {
    const { cnd, order } = this.state;
    const isAsc = order === 'asc';
    cnd.sort((a, b) => {
      let aValue = this.getValueColumnId(property, a);
      let bValue = this.getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
      }
      if (typeof bValue === 'string') {
        bValue = bValue.toLowerCase();
      }

      if (aValue == null) {
        return isAsc ? -1 : 1;
      }

      if (bValue == null) {
        return isAsc ? 1 : -1;
      }

      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    this.setState({ cnd });
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <Modal
          open={this.state.isModalOpen}
          onClose={this.closeModal}
          style={{
            top: this.state.modalPosition.top,
            left: this.state.modalPosition.left,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '5px',
              width: '300px',
            }}
          >
            <TextField
              label="Filtrar"
              variant="outlined"
              value={this.state.filterText}
              onChange={this.handleFilterTextChange}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.filterTable}
              style={{ marginTop: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.clearFilter}
              style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
            >
              Limpar
            </Button>
          </div>
        </Modal>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <h1>CND</h1>
          <Collapse in={this.state.openError}>
            <Alert severity="error" onClick={this.clickAlert}>
              Erro ao Salvar Certidão Negativa de Débito!
            </Alert>
          </Collapse>
          <Collapse in={this.state.openWarning}>
            <Alert severity="warning" onClick={this.clickAlert}>
              Usuário Não possui Histórico
            </Alert>
          </Collapse>
          <Collapse in={this.state.openSucess}>
            <Alert severity="success" onClick={this.clickAlert}>
              Certidão Negativa de Débito salva com sucesso!
            </Alert>
          </Collapse>
          <Paper className={classes.root}>
            <Collapse in={this.state.ready}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  padding: 10,
                }}
              >
                <Grid container>
                  <Grid item xs={6}>
                    <ListOfUsers
                      label="Nome do Cliente *"
                      width="40%"
                      userSelect={this.state.nomeUsuario}
                      setUserSelect={(user) =>
                        this.setState({ nomeUsuario: user })
                      }
                      setIdUsuario={(id) => this.handleChangeUsuario(id)}
                    />
                  </Grid>
                  <Grid item xs={3} />
                  <Grid item xs={3}>
                    <TextField
                      id="tipo"
                      select
                      fullWidth
                      label="Tipo CND"
                      value={this.state.tipo}
                      style={{ margin: 8, width: '100%' }}
                      onChange={(event) => this.handleChangeTipo(event)}
                    >
                      <MenuItem key="federal" value="CND">
                        Federal
                      </MenuItem>
                      <MenuItem key="municipal" value="CND MUNICIPAL">
                        Municipal
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      disabled={!this.state.idUsuario || !this.state.tipo}
                      variant="contained"
                      onClick={this.handleModal}
                      style={{
                        backgroundColor: XMEI_PRIMARY_COLOR,
                        color: '#FFF',
                        marginTop: 10,
                        marginBottom: 10,
                      }}
                    >
                      Adicionar
                    </Button>
                  </Grid>
                </Grid>
              </div>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {this.state.columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        sortDirection={
                          this.state.orderBy === column.id
                            ? this.state.order
                            : false
                        }
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <TableSortLabel
                            active={this.state.orderBy === column.id}
                            direction={
                              this.state.orderBy === column.id
                                ? this.state.order
                                : 'asc'
                            }
                            onClick={() => {
                              this.handleRequestSort(column.id);
                              setTimeout(() => {
                                this.sortTable(column.id);
                              }, 200);
                            }}
                          >
                            {column.label}
                          </TableSortLabel>

                          {column.filterable && (
                            <IconButton
                              style={{ marginLeft: -5 }}
                              onClick={(event) =>
                                this.openModal(event, column.id)
                              }
                              aria-label="filtra"
                            >
                              <FilterIcon style={{ width: 16, height: 16 }} />
                            </IconButton>
                          )}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.cnd.map((d) => {
                    return (
                      <TableRow>
                        <TableCell component="th" scope="row">
                          {d.data_geracao}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.situacao}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.tipo_servico === 'CND' ? 'Federal' : 'Municipal'}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Collapse>
          </Paper>
        </div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openModal}
          onClose={this.handleModal}
        >
          <div className={classes.paper}>
            <Grid container spacing={1} justify="left" alignItems="left">
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <h2 id="simple-modal-title" align="center">
                  Enviar Certidão Negativa
                </h2>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Collapse in={this.state.openWarningSend}>
                  <Alert severity="warning" onClick={this.clickAlert}>
                    Preencha todos os campos!
                  </Alert>
                </Collapse>
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                <TextField
                  select
                  label="Situacao"
                  labelId="situacao"
                  id="situacao"
                  value={this.state.situacao}
                  style={{ width: 150 }}
                  onChange={(data) => {
                    this.setState({ situacao: data.target.value });
                  }}
                >
                  <MenuItem value="Possui pendências">
                    Possui pendências
                  </MenuItem>
                  <MenuItem value="Sem pendências">Sem pendências</MenuItem>
                </TextField>
                <TextField
                  label="dataReferente"
                  id="dataReferente"
                  type="date"
                  style={{ width: 150 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={this.state.dataGeracao}
                  onChange={(data) => {
                    this.setState({ dataGeracao: data.target.value });
                  }}
                />
                <Button
                  startIcon={<CloudUploadIcon />}
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({ openModalAddFile: true })}
                  style={{
                    marginTop: '2%',
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    align: 'center',
                    maxWidth: 150,
                    maxHeight: 100,
                  }}
                >
                  {this.state.fileName
                    ? this.state.fileName.length > 10
                      ? `${this.state.fileName.substr(0, 10)}...`
                      : this.state.fileName
                    : 'Arquivo'}
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  paddingTop: '5%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.saveButton()}
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    align: 'center',
                  }}
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </div>
        </Modal>
        {this.handleAddFile(classes)}
        <Collapse in={this.state.ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </>
    );
  }
}
export default withStyles(useStyles)(CndComponent);
